import buffer from 'buffer'
export const columns = (vm) =>{
    return [
        {
            width:50,
            headerAlign:"center",
            align:"center",
            type:'selection',
        },
        {
            label:'项目名称',
            prop:'name',
            align:'center',
            headerAlign:'center',
            tooltip:true,
        },
        {
            label:'项目类型',
            prop:'projectType',
            align:'center',
            headerAlign:'center',
            tooltip:true,
            render:(h,param)=>{
                let txt = '';
                txt = param.row.projectType == 1?'消防':'新能源';
                return h('div',{},txt)
            }
        },
        {
            label:'项目所在地',
            prop:'areaAddress',
            align:'center',
            headerAlign:'center',
            width:300,
        },
        {
            label:'项目详址',
            prop:'address',
            align:'center',
            headerAlign:'center',
            width:300
        },
        {
            label:'设备数量',
            prop:'deviceCount',
            align:'center',
            headerAlign:'center'
        },
        {
            label:'项目所属',
            prop:'companyName',
            align:'center',
            headerAlign:'center'
        },
        {
            label:'创建时间',
            width:160,
            prop:'createTime',
            align:"center",
            headerAlign:"center"
        },
        {
            label:'操作',
            width:120,
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
                let del = (h)=>{
                    return h('el-button',{
                        props:{
                            type:'text'
                        },
                        style:{
                            padding:0
                        },
                        on:{
                            click:()=>{vm.operateShow(2,params.row)}
                        }
                    },'删除')
                }

                let query = (h)=>{
                    return h('el-button',{
                        props:{
                            type:'text'
                        },
                        style:{
                            padding:0
                        },
                        on:{
                            click:()=>{vm.operateShow(1,params.row)}
                        }
                    },'查看')
                }

                let btnArr = [];
                btnArr.push(query(h));
                // btnArr.push(del(h));

                return h('div',{},btnArr)
            }
        }
    ]
}